import { index } from 'd3'
import dayjs from 'dayjs'
import { numberFixDecimals } from '@local_modules/generic/numbers/number-fix-decimals/index.js'

import CurrenciesClient from '../../../../../../../server/currencies/index-client.js'

/**
 * Updates transactions with converted values
 * @param {Array} transactions
 * @param {Object} params
 * @param {Object} params.currenciesRates
 * @param {Object} params.entities
 * @param {Object} params.shownCurrencyCode
 */
export function convertValues (transactions, params) {
  const { currenciesRates, entities, shownCurrencyCode } = params
  const currencies = new CurrenciesClient()
  const ratesMap = currencies.mapRates(currenciesRates?.rates)
  const entitiesMap = index(entities, e => e.id)

  // Make sure numbers are numbers
  transactions.forEach(function (transaction) {
    transaction.ledger_amount = parseFloat(transaction.ledger_amount) || null
    transaction.source_currency_rate = parseFloat(transaction.source_currency_rate) || null

    transaction._in_currency_code = entitiesMap.get(transaction.chart_of_account_accounting_organisation_id)?.base_currency

    // if (shownCurrencyCode === transaction._currency_code) return
    const targetCurrencyCode = shownCurrencyCode === 'XXX' ? transaction._in_currency_code : shownCurrencyCode
    const targetConversionDate = dayjs(transaction.ledger_date).endOf('month').format('YYYY-MM-DD')

    const convertedValue = currencies.convert(transaction.ledger_amount, targetConversionDate, [transaction._in_currency_code, targetCurrencyCode], ratesMap)

    transaction._converted_amount = numberFixDecimals(convertedValue.convertedValue)
    transaction._converted_currency_code = shownCurrencyCode
    transaction._conversion = convertedValue
  })
  console.log('transactions', transactions)
}
